const personalDataFormChanges = () => {
    const presonalBlock = document.querySelector('[data-form="personal-data"]');

    try {
        presonalBlock.addEventListener('click', (e)=>{
            let target = e.target;

            if(target.classList.contains('write-btn')) {
                target.closest('.list-desc').classList.add('show-changes-block');
            }

            if(target.classList.contains('save-btn')) {
                let parentBlock     = target.closest('.list-desc'),
                    inputBlock      = parentBlock.querySelector('.input'),
                    titleBlock      = parentBlock.querySelector('.txt-desc'),
                    passBtn         = parentBlock.querySelector('.pass'),
                    // inputCheckbox   = parentBlock.querySelector('.input_checkbox'),
                    selectBlock     = parentBlock.querySelector('.select');
                
                parentBlock.classList.remove('show-changes-block');

                if(inputBlock) {
                    // if(inputBlock.value === '' || inputBlock.value === ' ' || inputBlock.value === null || inputBlock.value === 'undefined') {
                    //     return false;
                    // } else {

                    //     if(inputBlock.type == 'checkbox') {
                           

                    //         if(inputBlock.checked) {
                    //             titleBlock.textContent = inputBlock.value;
                    //         } else {
                    //             titleBlock.textContent = 'Значение чекбокса';
                    //         }
                    //     } else {
                    //         titleBlock.textContent = inputBlock.value;
                    //     }
                    // }
                    if (inputBlock.value === '' || inputBlock.value === ' ' || inputBlock.value === null || inputBlock.value === 'undefined') {
                         return false;
                    } else {
                         //titleBlock.textContent = inputBlock.value;
                    }
                }

                if(selectBlock) {
                    titleBlock.textContent = selectBlock.value;
                }

                

                // if(passBtn) {
                //     let inputNum = +inputBlock.value.length;
                //     titleBlock.textContent = '*';
                //     for (let i = 0; i < (inputNum - 1); i++) {
                //         if(inputNum != 1) {
                //             titleBlock.textContent += '*';
                //         }
                //     }
                // }   
                if (passBtn) {
                     var inputNum = +inputBlock.value.length;
                     titleBlock.textContent = '*';

                    for (var i = 0; i < inputNum - 1; i++) {
                       if (inputNum != 1) {
                         titleBlock.textContent += '*';
                       }
                    }
                }

            }
        });
    } catch(e){}
};

export default personalDataFormChanges;